import { useMutation } from '@apollo/client';
import { Button, Modal } from 'antd';
import React from 'react';
import {
  CONFIRMATION_REGISTER_MODAL_TITLES,
  CONFIRMATION_TYPES,
  REGISTER_STATUS_LABEL,
  ROUTES,
  TAB_KEYS,
} from '../../../../../../common/constants';
import useRouter from '../../../../../../common/useRouter';
import { UPDATE_REGISTER } from '../../../../graphql/Mutation';

const ConfirmationModal = ({
  type,
  showModal,
  setShowModal,
  handleRefetch,
}) => {
  const {
    navigate,
    params: { projectId, registerId },
  } = useRouter();
  const [updateRegister] = useMutation(UPDATE_REGISTER, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted() {
      handleRefetch();
    },
  });

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleSave = async () => {
    let updateStatus = null;

    switch (type) {
      case CONFIRMATION_TYPES.ARCHIVE:
        updateStatus = { status: REGISTER_STATUS_LABEL.ARCHIVED };
        break;

      case CONFIRMATION_TYPES.UNARCHIVE:
      case CONFIRMATION_TYPES.EDIT:
        updateStatus = { status: REGISTER_STATUS_LABEL.DRAFT };
        break;

      case CONFIRMATION_TYPES.SAVE:
        updateStatus = { status: REGISTER_STATUS_LABEL.LIVE };
        break;

      default:
        break;
    }

    if (updateStatus) {
      await updateRegister({
        variables: {
          updateRegisterId: registerId,
          data: updateStatus,
        },
      });
    }
    if (type === CONFIRMATION_TYPES.SAVE) {
      navigate(
        `${ROUTES.PROJECTS}/${projectId}/${TAB_KEYS.REGISTER}/${registerId}`,
      );
    }
    setShowModal(false);
  };

  return (
    <Modal
      maskClosable={false}
      centered
      open={showModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
    >
      <h2>CAUTION</h2>
      <p>{CONFIRMATION_REGISTER_MODAL_TITLES?.[type]?.TITLE}</p>
      <div className="form-buttons">
        <Button shape="round" className="cancel-button" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          shape="round"
          type="primary"
          className="save-button"
          onClick={handleSave}
        >
          {CONFIRMATION_REGISTER_MODAL_TITLES?.[type]?.BUTTON_TITLE}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
